
import React from 'react';
import { CheckBox } from 'react-admin-base-bootstrap';
import {Col, FormText, Row} from "reactstrap";

export default function SingleSelectCheck({ id, value, onChange, fields }) {
    return <Row>
        { fields.map(a => <Col md="6" key={a.id} className={a.desc ? 'mb-3' : ''}>
            <CheckBox
                id={id + "_" + a.id}
                type="radio"
                label={a.name}
                checked={value === a.id}
                onChange={() => onChange(a.id)}
            />
            { a.desc && <FormText color="muted">{a.desc}</FormText>}
        </Col>)}
    </Row>
}